import { useMemo } from 'react';
import { ServiceStatisticsGranularity, ServiceStatisticsMetricsDTO } from '../../dto/ServiceStatisticsDTO';
import PeakChips from './PeakChips';
import { markPeaks, PeakAnalysis } from './peaks';
import TimelineChart from './TimelineChart';
import { Measure, TimelinePoint } from './statisticsUtils';

interface TimelineEvolutionProps {
    points: TimelinePoint[];
    granularity: ServiceStatisticsGranularity;
    measure: Measure;
    ariaLabel: string;
    /** Los indicadores del período: de ahí sale el promedio ponderado de la línea de referencia (el mismo número de las cards). */
    current: ServiceStatisticsMetricsDTO;
    /** Abre el detalle de un período con atenciones; `opener` es a donde vuelve el foco al cerrar el panel. */
    onOpenPeriod: (point: TimelinePoint, opener: HTMLElement | null) => void;
}

/** El gráfico de evolución con sus picos marcados y, debajo, los chips «Picos» que abren el detalle de cada uno. */
export default function TimelineEvolution({ points, granularity, measure, ariaLabel, current, onOpenPeriod }: TimelineEvolutionProps) {
    const analysis = useMemo<PeakAnalysis | null>(() => (measure === 'attentions' ? null : markPeaks(points.map(point => ({
        value: measure === 'wait' ? point.avgWait : point.avgService,
        attentions: point.attentions,
    })))), [points, measure]);
    const average = measure === 'attentions' || current.attentions <= 0 ? null
        : measure === 'wait' ? current.avgWaitMinutes : current.avgServiceMinutes;

    return (
        <div className="ss-evolution">
            <TimelineChart points={points} granularity={granularity} measure={measure} ariaLabel={ariaLabel}
                average={average} analysis={analysis} onOpen={onOpenPeriod} />
            {analysis && measure !== 'attentions' && (
                <PeakChips points={points} granularity={granularity} measure={measure} analysis={analysis}
                    onOpen={onOpenPeriod} />
            )}
        </div>
    );
}
